<!--全局的下拉菜单-->
<template>
  <el-select
    v-model="selected.value"
    :filterable="filterable"
    @change="changeSelect"
    :disabled="disabled"
    :placeholder="placeholder"
  >
    <el-option
      v-for="(item) in list"
      :key="item[keyValue[0]]"
      :label="item[keyValue[1]]"
      :disabled="item.is_delete ? item.is_delete === '1' : false"
      :value="item[keyValue[0]]"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  data () {
    return {
      selectedValue: '',
      label: ''
    };
  },
  name: 'select-menu',

  props: {
    filterable: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      required: true,
      default: function () {
        return [];
      }
    },
    keyValue: {
      type: Array,
      required: false,
      default: function () {
        return ['value', 'name'];
      }
    },
    current: {
      type: Object,
      required: true,
      default: function () {
        return {
          value: ''
        };
      }
    },
    part: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: '请选择'
    }
  },
  computed: {
    selected () {
      return this.current;
    },
    curPart () {
      return this.part;
    }
  },
  methods: {
    changeSelect (id) {
      if (id === '') return;
      if (this.list.length === 0) {
        return;
      }
      let item = this.list.filter(item => {
        if (item.place) {
          return item.place === id;
        } else {
          return {};
        }
      })[0];
      let item2 = this.list.filter(item2 => {
        if (item2.orderid) {
          return item2.orderid === id;
        } else {
          return true;
        }
      })[0];
      this.$emit('changeSelectMenu', {
        select: this.selected ? this.selected.value : '',
        part: this.part,
        label: item.place_name ? item.place_name : '',
        payment: item2.payment ? item2.payment : '',
        adSlot: item2.advert_place ? item2.advert_place : '', // 广告位
        mobileType: item2.port_type ? item2.port_type : '',
        flowSource: item2.flow_source ? item2.flow_source : '', // 流量类型
        createType: item2.create_type ? item2.create_type : '', // 广告类型
        flowType: item2.flow_type ? item2.flow_type : '' // 媒体类型
      });
    }
  }
};
</script>
